document.addEventListener("DOMContentLoaded", function() {
    const benefitsButtons = document.querySelectorAll('.benefitsButton');

    if (benefitsButtons.length) {
        benefitsButtons.forEach((button, index) => {
            button.addEventListener('click', function() {
                if(!this.closest('.left_content_mashroom.open')){
                    document.querySelectorAll('.left_content_mashroom.open').forEach((button) => {
                        button.closest('.left_content_mashroom').classList.remove('open');
                    })
                }
                this.closest('.left_content_mashroom').classList.toggle('open');
                this.closest('.boa-my-mushroom-item').classList.toggle('open');
            });
        });
    }
});


function initReadMoreButtons() {
  const myMushroomSections = document.querySelectorAll("section.my-mushroom");
  myMushroomSections.forEach((section) => {
    const readMoreButtons = section.querySelectorAll(
      ".boa-my-mushroom-item .mushroom-read-more-button"
    );
    readMoreButtons.forEach((button) => {
      button.addEventListener("click", () => {
        readMoreButtons.forEach((button) => {
          button
            .closest(".boa-my-mushroom-item")
            ?.classList.toggle("read-more");
          button.style.display = "none";
        });
      });
    });
  });
}